import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ModernHeader = ({ 
  title, 
  subtitle, 
  icon: Icon, 
  themeColor = 'blue',
  children 
}) => {
  const { isDarkMode } = useTheme();
  const getThemeGradient = (color) => {
    const gradients = {
      blue: 'from-blue-600 via-blue-500 to-blue-400',
      green: 'from-green-600 via-green-500 to-green-400',
      purple: 'from-purple-600 via-purple-500 to-purple-400',
      orange: 'from-orange-600 via-orange-500 to-orange-400',
      red: 'from-red-600 via-red-500 to-red-400',
      indigo: 'from-indigo-600 via-indigo-500 to-indigo-400',
      pink: 'from-pink-600 via-pink-500 to-pink-400',
      teal: 'from-teal-600 via-teal-500 to-teal-400',
      yellow: 'from-yellow-600 via-yellow-500 to-yellow-400'
    };
    return gradients[color] || gradients.blue;
  };



  return (
    <div className="mb-6 sm:mb-8">
      <div className="flex items-start sm:items-center justify-between gap-3 sm:gap-0">
        <div className="flex items-center space-x-2 sm:space-x-4">
          {Icon && (
            <div className={`
              w-8 h-8 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center shadow-md sm:shadow-lg border 
              ${isDarkMode ? 'bg-[#1a2230] border-white/10' : `bg-gradient-to-br ${getThemeGradient(themeColor)} border-transparent`}
            `}>
              <Icon className={`w-4 h-4 sm:w-5 sm:h-5 ${isDarkMode ? 'text-white' : 'text-white'}`} />
            </div>
          )}
          <div>
            <h1 className={`
              text-2xl sm:text-3xl font-bold bg-gradient-to-r ${getThemeGradient(themeColor)}
              bg-clip-text text-transparent leading-tight
            `}>
              {title}
            </h1>
            {subtitle && (
              <p className={`mt-1 text-sm sm:text-base ${
                isDarkMode ? 'text-gray-400' : 'text-gray-600'
              }`}>
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {children && (
          <div className="flex items-center space-x-2 sm:space-x-3">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModernHeader;